class DateFormatOverridden extends Intl.DateTimeFormat {
    format(date) {
        if (typeof date === 'string') {
            const parsedDate = Date.parse(date)
            if (isNaN(parsedDate)) {
                console.error(`Invalid date: "${date}"`)
                return ''
            }
            date = parsedDate
        }

        if (isNaN(date)) {
            console.error(`Invalid date: "${date}"`)
            return ''
        }

        try {
            const parts = super.formatToParts(date)
            const map = {}
            parts.forEach(item => {
                if (item.value.length < 2) {
                    item.value = '0' + item.value
                }
                map[item.type] = item.value
            })
            return `${map.day}.${map.month}.${map.year}`
        } catch (e) {
            console.error(`Invalid date: "${date}"`, e)
            return ''
        }
    }
}

export default {
    install: function (vue, options) {
        Intl.DateTimeFormat = DateFormatOverridden
    }
}
